import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext({
    isLoggedIn: false,
    setIsLoggedIn: () => { },
    user: null,
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const checkLoginStatus = async () => {
            await fetchLoginStatus();          
        };

        checkLoginStatus();
    }, []);

    const fetchLoginStatus = async () => {
        try {
            const response = await fetch('/auth/session/check-auth', {
                method: 'POST', // Or 'POST', based upon your endpoint
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.ok) {
                // Assuming your API returns user data on successful login                
                return setIsLoggedIn(true);
            }
           return setIsLoggedIn(false);
           //return setIsLoggedIn(true); //for testing
        } catch (error) {
            console.error('Failed to check login status', error);
            return setIsLoggedIn(false);
            //return setIsLoggedIn(true); //for testing
        }
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn}}>
            {children}
        </AuthContext.Provider>
    );
};